import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class FieldCustomization extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} customFrameClass={"field-custom-container"} pageTitle={"Field Customization"} formname={"table_33"} customClass={"field-customization-container legacy-frame-for-settings "} />
        );
    }
}

export default FieldCustomization;
